// ContactDetails.js

import React from "react";
import "./ContactDetails.css";

function ContactDetails() {
  return (
    <section id="contact" className="contact-section">
      <h2>Contact Details</h2>

      <p className="contact-text">Email: hamzaaleem755@gmail.com</p>
      <p className="contact-text">Phone: +923002877787</p>

      <a
        href="https://www.linkedin.com/in/hamzaaleem2003/"
        className="contact-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        LinkedIn
      </a>
      <a
        href="https://github.com/hamzaaleem2003"
        className="contact-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        GitHub
      </a>
    </section>
  );
}

export default ContactDetails;
